import * as _ from 'lodash';
import { fromJS } from 'immutable';

import { fetchingState } from '@constants';
import * as actions from '../actions/deed';
import { SUCCESS, START, ERROR } from '../actions/global';

const initialStats = {
  deed: { data: {}, state: null },
  deeds: {},
  deedList: { data: [], state: null },
  deedTypeList: { data: [], state: null },
  deedProperty: { data: {}, state: null },
  deedPropertyList: { data: [], state: null },
  fileList: { data: [], state: null },
  sellerList: { data: [], state: null },
  buyerList: { data: [], state: null },
  deedLookupModal: {
    open: false,
    mode: null,
    propertyId: null,
    state: '',
    data: [],
    selection: [],
  },
  letterCodes: [],
};

const normalizeFileAttachment = deedList =>
  deedList.map(elem => {
    return {
      ...elem,
      fileAttachment: elem.fileAttachment
        ? JSON.parse(elem.fileAttachment)
        : [],
    };
  });

export default (state = fromJS(initialStats), action) => {
  switch (action.type) {
    case actions.DEED_FETCH_MOST_CURRENT[START]:
    case actions.DEED_FETCH_START: {
      return state
        .setIn(['deed', 'data'], fromJS({}))
        .setIn(['deed', 'state'], fetchingState.FETCHING);
    }
    case actions.DEED_FETCH_MOST_CURRENT[SUCCESS]:
    case actions.DEED_FETCH_SUCCESS: {
      return state
        .setIn(['deed', 'state'], fetchingState.LOADED)
        .setIn(['deed', 'data'], fromJS(_.get(action, 'data.results[0]', {})));
    }
    case actions.DEED_FETCH_MOST_CURRENT[ERROR]:
    case actions.DEED_FETCH_ERROR: {
      return state.setIn(['deed', 'state'], fetchingState.ERROR);
    }

    case actions.DEED_TYPES_FETCH_START: {
      return state.setIn(['deedTypeList', 'state'], fetchingState.FETCHING);
    }
    case actions.DEED_TYPES_FETCH_SUCCESS: {
      return state
        .setIn(['deedTypeList', 'state'], fetchingState.LOADED)
        .setIn(
          ['deedTypeList', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.DEED_TYPES_FETCH_ERROR: {
      return state.setIn(['deedTypeList', 'state'], fetchingState.ERROR);
    }

    case actions.DEEDS_FETCH_START: {
      return state
        .setIn(['deedList', 'data'], fromJS([]))
        .setIn(['deedList', 'state'], fetchingState.FETCHING);
    }
    case actions.DEEDS_FETCH_SUCCESS: {
      return state
        .setIn(['deedList', 'state'], fetchingState.LOADED)
        .setIn(
          ['deedList', 'data'],
          fromJS(normalizeFileAttachment(_.get(action, 'data.results', []))),
        );
    }
    case actions.DEEDS_FETCH_ERROR: {
      return state.setIn(['deedList', 'state'], fetchingState.ERROR);
    }

    case actions.DEED_DELETE_SUCCESS: {
      return state.setIn(
        ['deedList', 'data'],
        fromJS(
          state
            .getIn(['deedList', 'data'])
            .toJS()
            .filter(n => n.deedID !== action.deedId),
        ),
      );
    }

    case actions.DEEDS_REORDER_SUCCESS: {
      return state
        .setIn(['deedList', 'state'], fetchingState.LOADED)
        .setIn(
          ['deedList', 'data'],
          fromJS(normalizeFileAttachment(_.get(action, 'data.results', []))),
        );
    }

    case actions.DEED_CREATE_START: {
      return state.setIn(['deed', 'state'], fetchingState.SAVING);
    }
    case actions.DEED_CREATE_SUCCESS: {
      return state
        .setIn(['deed', 'state'], fetchingState.LOADED)
        .setIn(
          ['deed', 'data'],
          fromJS(_.get(action, 'data.results.deed[0]', {})),
        );
    }
    case actions.DEED_CREATE_ERROR: {
      return state.setIn(['deed', 'state'], fetchingState.ERROR);
    }

    case actions.DEED_PROPERTIES_FETCH_START: {
      return state
        .setIn(['deedPropertyList', 'data'], fromJS([]))
        .setIn(['deedPropertyList', 'state'], fetchingState.FETCHING);
    }
    case actions.DEED_PROPERTIES_FETCH_SUCCESS: {
      return state
        .setIn(['deedPropertyList', 'state'], fetchingState.LOADED)
        .setIn(
          ['deedPropertyList', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.DEED_PROPERTIES_FETCH_ERROR: {
      return state.setIn(['deedPropertyList', 'state'], fetchingState.ERROR);
    }

    case actions.DEED_PROPERTY_CREATE_START: {
      return state.setIn(['deedProperty', 'state'], fetchingState.SAVING);
    }
    case actions.DEED_PROPERTY_CREATE_SUCCESS: {
      return state
        .setIn(['deedProperty', 'state'], fetchingState.LOADED)
        .setIn(
          ['deedProperty', 'data'],
          fromJS(_.get(action, 'data.results.deed[0]', {})),
        );
    }
    case actions.DEED_PROPERTY_CREATE_ERROR: {
      return state.setIn(['deedProperty', 'state'], fetchingState.ERROR);
    }

    case actions.DEED_PROPERTY_FETCH_START: {
      return state
        .setIn(['deedProperty', 'data'], fromJS({}))
        .setIn(['deedProperty', 'state'], fetchingState.FETCHING);
    }
    case actions.DEED_PROPERTY_FETCH_SUCCESS: {
      return state
        .setIn(['deedProperty', 'state'], fetchingState.LOADED)
        .setIn(
          ['deedProperty', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case actions.DEED_PROPERTY_FETCH_ERROR: {
      return state.setIn(['deedProperty', 'state'], fetchingState.ERROR);
    }

    case actions.DEED_PROPERTY_DELETE_SUCCESS: {
      return state.setIn(
        ['deedPropertyList', 'data'],
        fromJS(
          state
            .getIn(['deedPropertyList', 'data'])
            .toJS()
            .filter(n => n.deedPropertyID !== action.deedPropertyID),
        ),
      );
    }

    case actions.FILES_FETCH_START: {
      return state.setIn(['fileList', 'state'], fetchingState.FETCHING);
    }
    case actions.FILES_FETCH_SUCCESS: {
      return state
        .setIn(['fileList', 'state'], fetchingState.LOADED)
        .setIn(
          ['fileList', 'data'],
          fromJS(_.get(action, 'data.results[0].fileAttachment', [])),
        );
    }
    case actions.FILES_FETCH_ERROR: {
      return state.setIn(['fileList', 'state'], fetchingState.ERROR);
    }

    case actions.FILE_CREATE_START:
    case actions.FILE_UPDATE_START: {
      return state.setIn(['fileList', 'state'], fetchingState.SAVING);
    }
    case actions.FILE_CREATE_SUCCESS:
    case actions.FILE_UPDATE_SUCCESS: {
      return state
        .setIn(['fileList', 'state'], fetchingState.LOADED)
        .setIn(
          ['fileList', 'data'],
          fromJS(_.get(action, 'data.results[0].fileAttachment', [])),
        );
    }
    case actions.FILE_CREATE_ERROR:
    case actions.FILE_UPDATE_ERROR: {
      return state.setIn(['fileList', 'state'], fetchingState.ERROR);
    }

    case actions.FILE_DELETE_START: {
      return state.setIn(['fileList', 'state'], fetchingState.SAVING);
    }
    case actions.FILE_DELETE_SUCCESS: {
      return state.setIn(['fileList', 'state'], fetchingState.LOADED).setIn(
        ['fileList', 'data'],
        fromJS(
          state
            .getIn(['fileList', 'data'])
            .toJS()
            .filter(document => document.s3ID !== action.s3ID),
        ),
      );
    }
    case actions.FILE_DELETE_ERROR: {
      return state.setIn(['fileList', 'state'], fetchingState.ERROR);
    }

    case actions.DEED_SELLERS_FETCH_START: {
      return state
        .setIn(['sellerList', 'data'], fromJS([]))
        .setIn(['sellerList', 'state'], fetchingState.FETCHING);
    }
    case actions.DEED_SELLERS_FETCH_SUCCESS: {
      return state
        .setIn(['sellerList', 'state'], fetchingState.LOADED)
        .setIn(
          ['sellerList', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.DEED_SELLERS_FETCH_ERROR: {
      return state.setIn(['sellerList', 'state'], fetchingState.ERROR);
    }

    case actions.DEED_BUYERS_FETCH_START: {
      return state
        .setIn(['buyerList', 'data'], fromJS([]))
        .setIn(['buyerList', 'state'], fetchingState.FETCHING);
    }
    case actions.DEED_BUYERS_FETCH_SUCCESS: {
      return state
        .setIn(['buyerList', 'state'], fetchingState.LOADED)
        .setIn(
          ['buyerList', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.DEED_BUYERS_FETCH_ERROR: {
      return state.setIn(['buyerList', 'state'], fetchingState.ERROR);
    }

    case actions.RESET_DEED: {
      return state.setIn(['deed', 'data'], fromJS({}));
    }

    case actions.SET_CURRENT_DEED: {
      return state.setIn(
        ['deed', 'data'],
        fromJS(_.get(action, 'payload', {})),
      );
    }

    // deed lookup modal
    case actions.OPEN_DEED_LOOKUP_MODAL: {
      return state.set(
        'deedLookupModal',
        fromJS({
          open: true,
          mode: action.payload.mode,
          propertyId: action.payload.propertyId,
          state: null,
          data: state.getIn(['deedLookupModal', 'data']).toJS(),
          selection: [],
        }),
      );
    }
    case actions.CLOSE_DEED_LOOKUP_MODAL: {
      return state.setIn(['deedLookupModal', 'open'], false);
    }
    case actions.LOOKUP_DEED[START]: {
      return state.setIn(['deedLookupModal', 'state'], fetchingState.FETCHING);
    }
    case actions.LOOKUP_DEED[SUCCESS]: {
      return state
        .setIn(['deedLookupModal', 'state'], fetchingState.LOADED)
        .setIn(
          ['deedLookupModal', 'data'],
          fromJS(normalizeFileAttachment(_.get(action, 'data.results', []))),
        );
    }
    case actions.LOOKUP_DEED[ERROR]: {
      return state.setIn(['deedLookupModal', 'state'], fetchingState.ERROR);
    }
    case actions.MODAL_SELECT_DEED_RECORDS: {
      return state.setIn(['deedLookupModal', 'selection'], action.payload);
    }

    case actions.DEED_FETCH_DEEDS_START:
      return state.setIn(['deeds', 'state'], fetchingState.FETCHING);
    case actions.DEED_FETCH_DEEDS_SUCCESS:
      let newState = state.setIn(['deeds', 'state'], fetchingState.LOADED);
      newState = newState.setIn(
        ['deeds', 'total'],
        fromJS(action.data ? action.data.totalProperty.deedCount : 0),
      );
      return newState.setIn(
        ['deeds', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.DEED_FETCH_DEEDS_ERROR:
      return state.setIn(['deeds', 'state'], fetchingState.ERROR);

    case actions.DEED_FETCH_LETTER_CODES[SUCCESS]: {
      return state.setIn(
        ['letterCodes'],
        fromJS(_.get(action, 'data.results', [])),
      );
    }

    case actions.DEED_ADD_LETTER_CODE[SUCCESS]: {
      let letterCodes = state.getIn(['letterCodes']).toJS();

      return state.setIn(
        ['letterCodes'],
        fromJS(letterCodes.concat(action.data.results)),
      );
    }

    case actions.DEED_DELETE_LETTER_CODE[SUCCESS]: {
      let letterCodes = state.getIn(['letterCodes']).toJS();
      return state.setIn(
        ['letterCodes'],
        fromJS(
          letterCodes.filter(
            l => l.deedLetterCodeID !== action.deedLetterCodeID,
          ),
        ),
      );
    }

    default: {
      return state;
    }
  }
};
